import React from "react";
import PropTypes from "prop-types";

import mutationFactory, {
  activateCard as activateCardQ,
  blockCard as blockCardQ,
} from "model/gql/mutations";

const ActivateCardMutation = mutationFactory(activateCardQ);
const BlockCardMutation = mutationFactory(blockCardQ);

function CardStatusSwitch(props) {
  const { cardId, blockReasonId, blockComment, children } = props;
  return cardId ? (
    <ActivateCardMutation cardId={props.cardId}>
      {({ mutate: activateCard }) =>
        blockReasonId ? (
          <BlockCardMutation
            cardId={cardId}
            blockReasonId={blockReasonId}
            blockComment={blockComment}
          >
            {({ mutate: blockCard }) => children({ activateCard, blockCard })}
          </BlockCardMutation>
        ) : (
          children({ activateCard, blockCard: undefined })
        )
      }
    </ActivateCardMutation>
  ) : (
    children({ activateCard: undefined, blockCard: undefined })
  );
}

// {({ activateCard: mutate }) => (
//   <blockCardMutation
//     cardId={props.cardId}
//     blockReasonId={props.blockReasonId}
//     blockComment={props.blockComment}
//   >
//     {({ blockCard: mutate }) =>
//       props.children({ activateCard, blockCard })
//     }
//   </blockCardMutation>
// )}

CardStatusSwitch.displayName = "CardStatusSwitch";

CardStatusSwitch.propTypes = {
  children: PropTypes.func.isRequired,
  cardId: PropTypes.string.isRequired,
  blockReasonId: PropTypes.string,
  blockComment: PropTypes.string,
};

CardStatusSwitch.defaultProps = {};

export default CardStatusSwitch;



// WEBPACK FOOTER //
// ./src/data-containers/CardStatusSwitch/CardStatusSwitch.js